<app-common-header-layout
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <div class="message-container">
    <div class="success-icon-wrapper">
      <i2g-icon class="success-icon" [icon]="successIcon"> </i2g-icon>
    </div>

    <h1 class="title" e2eId="title">
      {{ 'SET_PASSWORD.SET_PASSWORD_SUCCESS_TITLE' | translate }}
    </h1>

    <h2
      class="sub-title"
      e2eId="sub-title"
      [innerHTML]="
        'SET_PASSWORD.SET_PASSWORD_SUCCESS_MESSAGE' | translate | safe: 'html'
      "
    ></h2>

    <i2g-router-link
      class="action"
      e2eId="login"
      buttonStyle="emphasis"
      [alignment]="AlignmentEnum.center"
      [label]="'ACTION.LOG_IN' | translate"
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="loginTrackingAction"
      (click)="goToLogin()"
    >
    </i2g-router-link>
  </div>
</app-common-header-layout>
